<div class="modal-header">
  <h5 class="modal-title">{{ order.id ? 'Edit' : 'Add' }} Order</h5>
  <button type="button" class="close" aria-label="Close" (click)="onCancelClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form>
    <div class="form-group">
      <label for="orderNumber">
        Order Number
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Description:</b> Enter the unique order number."></i>
      </label>
      <input type="text" class="form-control" id="orderNumber" [(ngModel)]="order.orderNumber" name="orderNumber" placeholder="e.g., ORD-12345">
    </div>
    <div class="form-group">
      <label for="orderDate">
        Order Date
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Description:</b> Select the date of the order."></i>
      </label>
      <input type="date" class="form-control" id="orderDate" [(ngModel)]="order.orderDate" name="orderDate" placeholder="e.g., 2023-10-03">
    </div>
    <div class="form-group">
      <label for="vendor">
        Vendor
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Description:</b> Select the vendor for this order."></i>
      </label>
      <select class="form-control" id="vendor" [(ngModel)]="order.vendor" name="vendor">
        <option *ngFor="let vendor of vendors" [ngValue]="vendor">{{ vendor.name }}</option>
      </select>
    </div>
    <div class="form-group">
      <label for="totalCost">
        Total Cost
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Description:</b> Enter the total cost of the order."></i>
      </label>
      <input type="number" class="form-control" id="totalCost" [(ngModel)]="order.totalCost" name="totalCost" step="0.01" placeholder="e.g., 99.99">
    </div>
    <div class="form-group">
      <label for="status">
        Status
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Description:</b> Enter the current status of the order."></i>
      </label>
      <select class="form-control" id="status" [(ngModel)]="order.status" name="status">
        <option value="" disabled selected>Select Status</option>
        <option value="Pending">Pending</option>
        <option value="Cancelled">Cancelled</option>
        <option value="Shipped">Shipped</option>
        <option value="Delivered">Delivered</option>
    </select>
    
    </div>
    <div class="form-group">
      <label for="notes">
        Notes
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Description:</b> Add any additional notes regarding the order."></i>
      </label>
      <textarea class="form-control" id="notes" [(ngModel)]="order.notes" name="notes" placeholder="e.g., Deliver by end of the week"></textarea>
    </div>
    <div class="form-group">
      <label for="contract">
        Contract
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Description:</b> Select the related contract."></i>
      </label>
      <select class="form-control" id="contract" [(ngModel)]="order.contract" name="contract">
        <option *ngFor="let contract of contracts" [ngValue]="contract">{{ contract.contractNumber }}</option>
      </select>
    </div>
    <div class="form-group">
      <label for="invoice">
        Invoice
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Description:</b> Select the associated invoice."></i>
      </label>
      <select class="form-control" id="invoice" [(ngModel)]="order.invoice" name="invoice">
        <option *ngFor="let invoice of invoices" [ngValue]="invoice">{{ invoice.invoiceNumber }}</option>
      </select>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="onCancelClick()">Cancel</button>
  <button type="button" class="btn btn-outline-primary" (click)="onSaveClick()">Save</button>
</div>

